import React, { useState, useEffect } from   'react';
import RecepcionHeaderEstadoDXdia from "./Componentes/HeaderDatosEstadoDXdia";
import { useNavigate } from 'react-router-dom';
import { FaUser } from 'react-icons/fa';
import { useAuth } from '../../Auth/AuthContext';
import apiService from './../../Auth/apiService';
import CargandoSpinner from './../Utils/CargandoSpinner';
import SeccionPageHeader from './../Utils/SeccionPageHeader';
import SweetAlert2 from 'react-sweetalert2';
import { Card } from 'react-bootstrap';

export default function Diagnosticodx() {
    const { user, token, rol, sedeActual, nombre } = useAuth();
    const [Cargando, setCargando] = useState(false);
    const navigate = useNavigate();
    const [swalProps, setSwalProps] = useState({});
    const [asignandoDX, setAsignandoDX] = useState(false);
    const [profesionales, setProfesionales] = useState([]);
    const [listaDxPrioridadEspecialProfesional, setListaDxPrioridadEspecialProfesional] = useState([]);
    const [listaDxPendientesporTerminar, setListaDxPendientesporTerminar] = useState([]);
    const [listaDxHoy, setListaDxHoy] = useState([]);
    const [sedes, setSedes] = useState([]);
    const [cantidadManual, setCantidadManual] = useState(0);
    const [datosFecha, setDatosFecha] = useState({});
    const ConsultarSedes = React.useCallback(async () => {
        const url = '/diagnostico/recepcion/listarsedes';
        try {
            setCargando(true);
            const response = await apiService.get(url, token);
            const result = await response.data;
            setSedes(result);
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setCargando(false);
        }
      }, [token]);
    
    const ListarRecepcionDeclaracionesPorProfesional = React.useCallback(async () => {
        const url = '/diagnostico/recepcion/listarrecepcionesporprofesional';
        const obj = { usrId: user, sede: sedeActual || '' };
        setCargando(true);
        try {
            const response = await apiService.post(url, obj, token);
            if (response.status === 200) {
                setListaDxPendientesporTerminar(response.data.listarecepcionesporprofesional.filter(item => item.rep_estadoatencion === 2));
                setListaDxPrioridadEspecialProfesional(response.data.listarecepcionesporprofesional.filter(item => item.rep_estadoatencion === 1));
                setListaDxHoy(response.data.listarecepcionesporprofesional.filter(item => item.rep_estadoatencion === 3));
            }
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setCargando(false);
        }
    }, [user, sedeActual, token]);
    const estoes = (action) => {
        const sede = sedes.find(item => item.sedNombre === action);
        const sedeId = sede ? sede.id : sedeActual;
        DatosRecepcionFecha(sedeId)
    };
    const DatosRecepcionFecha = React.useCallback(async (sede) => {
          const url = '/diagnostico/recepcion/datosfecha';
          const obj = { sede: Number.parseInt(sede)}
          try {
              setCargando(true);
              const response = await apiService.post(url, obj, token);
              const result = await response.data;
              setProfesionales(result.profesionales || []);
                if (Array.isArray(result.result) && result.result.length > 0) {
                    setDatosFecha(result.result[0]);
                } else {
                    setDatosFecha({});
                }
              
          } catch (error) {
              console.error('Error fetching data:', error);
          } finally {
              setCargando(false);
          }
      }, [token]);
    function ConsultarfichosDia(sede) {
        const url = '/diagnostico/recepcion/consultarcantidadfichosdia';
        const obj = { sede: Number.parseInt(sede) }
        apiService.post(url, obj, token)
        .then(response => {
            const result = response.data;
            if (response.status === 200) {
            setCantidadManual(result.ficConstanciasrecibidas);
            } else {
            setSwalProps({
                title: 'Error',
                text: result.message,
                icon: 'error'
            });
            }
        })
        .catch(error => {
            console.error('Error fetching fichos:', error);
            setSwalProps({
            title: 'Error',
            text: 'No se pudo obtener la cantidad de fichos del día',
            icon: 'error'
            });
        });
    }
    useEffect(() => {
        ConsultarfichosDia(sedeActual);
        ListarRecepcionDeclaracionesPorProfesional();
        ConsultarSedes();
        DatosRecepcionFecha(sedeActual);
    }, [sedeActual, ListarRecepcionDeclaracionesPorProfesional, ConsultarSedes, DatosRecepcionFecha])
    const AbrirDXIdentificacion = (iddx, idrecepcion) =>  {
        navigate(`/dx/identificacion/${iddx}/${idrecepcion}`);
    };
    const Mensaje = (title, text) => {
        setSwalProps({
            show: true,
            title: title,
            text: text,
        });
    };
    async function AsignarDXProfesional() {
        const url = '/diagnostico/asignardxaprofesional';
        const obj = { usrId: user, sede: sedeActual };
        setCargando(true);
        await apiService.post(url, obj, token)
        .then((response) => {
            if (response.status === 200) {
                AbrirDXIdentificacion(0, response.data.recepcion);
            }
        })
        .catch((error) => {
            Mensaje('Error', 'No se pudo asignar el diagnostico');
            console.error('Error fetching data:', error);
        })
        .finally(() => {
            setCargando(false);
        });
    }
    return (
        <div className="content-wrapper">
            <SeccionPageHeader  
                title="Diagn&oacute;stico base"
                idCabezaFamilia="0"
                nombreurl="Administrar caracterización"
                nombreform=" Diagn&oacute;stico base"
            />
            <CargandoSpinner Cargando={Cargando}/>
            <section className="content">
                <div className="container-fluid">
                    <div className='card'>
                        <div className="box-header float-sm-right">
                            <RecepcionHeaderEstadoDXdia 
                                datosFecha={datosFecha} 
                                sedes={sedes} 
                                actionSedes={estoes}
                                sedeActual = {sedeActual}
                                showSelectSede={rol === '2'}
                                cantidadManual={cantidadManual}
                                Profesionales={profesionales}
                            />                            
                        </div>
                    </div>
                
                    <div id="divDiagnosticosPendientes" className="row">
                        <div className="row">
                        <div className="col-md-3 col-sm-3 col-xs-3">
                            <div className="info-box">
                            <span className="info-box-icon bg-blue"><FaUser/></span>
                            <div id="divbtnRealizarDX" className="info-box-content">
                                Pendientes: <b><span id="infCantDxPendientes">{datosFecha.familiaspendientes ?? 0}</span></b>
                                <button 
                                    id="btnRealizarDx" 
                                    type="button" 
                                    className="btn btn-primary"
                                    onClick={async () => {
                                        await AsignarDXProfesional();
                                    }}
                                    disabled={asignandoDX}
                                    >Realizar Diagn&oacute;stico</button>
                            </div>
                            {/* /.info-box-content */}
                            </div>
                            {/* /.info-box */}
                        </div>
                        </div> 
                        <Card>
                            <Card.Body>
                                <div className="row">
                                    <div id="tituloPrioridadEspecial" className="col-sm-12 col-md-12">
                                        <h4 className="text-center">Diagn&oacute;sticos Asignados con prioridad especial para: {nombre}</h4>
                                        <div id="listaDxPrioridadEspecialProfesional">
                                            <table className="table table-bordered">
                                                <thead>
                                                    <tr>
                                                        <th>ID</th>
                                                        <th>Documento</th>
                                                        <th>Nombre</th>
                                                        <th>Acciones</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {listaDxPrioridadEspecialProfesional.map((dx) => (
                                                        <tr key={dx.id}>
                                                            <td>{dx.id}</td>
                                                            <td>{dx.rep_identificacion}</td>
                                                            <td>{dx.nombrecompleto}</td>
                                                            <td>
                                                                <button 
                                                                    type='button'
                                                                    className="btn btn-primary"
                                                                    onClick={() => AbrirDXIdentificacion(dx.iddx ?? '0', dx.id)}>
                                                                    realizar Diagnostico
                                                                </button>
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>        
                            </Card.Body>
                        </Card>       
                        <div>&nbsp;</div>
                        <Card>
                            <Card.Body>
                                <div className="row">
                                    <div id="tituloDxPendientesparaProfesional" className="col-sm-12 col-md-12">
                                        <h4 className="text-center">Usted Tiene Diagn&oacute;sticos pendientes por terminar</h4>
                                        <div id="listaDxPendientesporTerminar">
                                            <table className="table table-bordered">
                                                <thead>
                                                    <tr>
                                                        <th>ID</th>
                                                        <th>Documento</th>
                                                        <th>Nombre</th>
                                                        <th>Acciones</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {listaDxPendientesporTerminar.map((dx) => (
                                                        <tr key={dx.id}>
                                                            <td>{dx.id}</td>
                                                            <td>{dx.rep_identificacion}</td>
                                                            <td>{dx.nombrecompleto}</td>
                                                            <td>
                                                                <button 
                                                                    type='button'
                                                                    className="btn btn-primary"
                                                                    onClick={() => AbrirDXIdentificacion(dx.iddx, dx.id)}>
                                                                    ir al Diagnostico
                                                                </button>
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>        
                            </Card.Body>
                        </Card>
                        <Card>
                            <Card.Body>
                                <div className="row">
                                    <div id="tituloDxFinalizadosparaProfesional" className="col-sm-12 col-md-12">
                                        <h4 className="text-center">Diagn&oacute;sticos finalizados</h4>
                                        <div id="listaDxFinalizados">
                                            <table className="table table-bordered">
                                                <thead>
                                                    <tr>
                                                        <th>ID</th>
                                                        <th>Documento</th>
                                                        <th>Nombre</th>
                                                        <th>Acciones</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {listaDxHoy.map((dx) => (
                                                        <tr key={dx.id}>
                                                            <td>{dx.id}</td>
                                                            <td>{dx.rep_identificacion}</td>
                                                            <td>{dx.nombrecompleto}</td>
                                                            <td>
                                                                <button 
                                                                    type='button'
                                                                    className="btn btn-primary"
                                                                    onClick={() => AbrirDXIdentificacion(dx.iddx, dx.id)}>
                                                                    ir al Diagnostico
                                                                </button>
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>        
                            </Card.Body>
                        </Card>
                    </div>

                </div> 
                <SweetAlert2 {...swalProps} 
                didClose={() => {
                    setSwalProps({})
                }}/>
            </section>
        </div>
    )
  }